import { Button, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { CopyFilled, CopyRegular } from '@fluentui/react-icons';
import { useFabricContext } from '@idmc-ms-fabric/integration';
import { useCallback, useState } from 'react';
const useStyles = makeStyles({
	root: {
		display: 'flex',
		alignItems: 'center',
		...shorthands.gap('10px'),
		color: tokens.colorBrandBackground2,
	},
	linkColor: {
		color: tokens.colorBrandBackground,
	},
});

const CopyLink = ({ url, urlText, showCopyIcon }: { url: string; urlText?: string; showCopyIcon?: boolean }) => {
	const [copied, setCopied] = useState<boolean>(false);
	const styles = useStyles();
	const { extensionClient } = useFabricContext();
	const copyToClipboard = () => {
		navigator.clipboard.writeText(url).then(() => {
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		});
	};

	const handleOnClick = useCallback(async () => {
		try {
			await extensionClient.navigation.openBrowserTab({ url });
		} catch (err) {
			console.log(err);
		}
	}, [url]);
	return (
		<div className={styles.root}>
			<Button className={styles.linkColor} onClick={handleOnClick} appearance="transparent" shape="rounded" size="small">
				{urlText ? urlText : url}
			</Button>
			{showCopyIcon ? (
				<Button
					iconPosition="before"
					appearance="transparent"
					shape="rounded"
					size="small"
					icon={copied ? <CopyFilled /> : <CopyRegular />}
					onClick={copyToClipboard}
				>
					{copied ? 'Copied' : 'Copy'}
				</Button>
			) : null}
		</div>
	);
};

export default CopyLink;
